import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useLegend } from '../../contexts/legendContext';
import { usePlotContext } from '../../contexts/plotContext';
import { useIsSeriesVisible, useShift } from '../../hooks';
import { functionalStyle, useId, validateAxis } from '../../utils';
import { ScatterSeries } from './ScatterSeries';
export function BarSeries(props) {
    var _a;
    const [, legendDispatch] = useLegend();
    const { colorScaler } = usePlotContext();
    const id = useId(props.id, 'series');
    const { lineStyle = {}, displayMarkers = false, hidden, ...otherProps } = props;
    const { xAxis = 'x', yAxis = 'y', xShift: oldXShift = '0', yShift: oldYShift = '0', pointLabel, displayErrorBars, label, markerStyle, markerShape, } = otherProps;
    const { xShift, yShift } = useShift({
        xAxis,
        yAxis,
        xShift: oldXShift,
        yShift: oldYShift,
    });
    const lineProps = {
        id,
        data: props.data,
        xAxis,
        yAxis,
        lineStyle: functionalStyle({}, lineStyle, { id }),
        transform: `translate(${xShift},${yShift})`,
    };
    const colorLine = (lineStyle === null || lineStyle === void 0 ? void 0 : lineStyle.stroke)
        ? lineStyle === null || lineStyle === void 0 ? void 0 : lineStyle.stroke.toString()
        : colorScaler(id);
    const color = ((_a = markerStyle === null || markerStyle === void 0 ? void 0 : markerStyle.fill) === null || _a === void 0 ? void 0 : _a.toString()) || colorScaler(id);
    const figure = markerShape || 'circle';
    const shape = useMemo(() => {
        return {
            color,
            figure,
            hidden: !displayMarkers,
        };
    }, [color, displayMarkers, figure]);
    const isVisible = useIsSeriesVisible(id);
    useEffect(() => {
        if (!hidden) {
            legendDispatch({
                type: 'ADD_LEGEND_LABEL',
                payload: {
                    id,
                    label,
                    colorLine,
                    shape,
                },
            });
            return () => legendDispatch({ type: 'REMOVE_LEGEND_LABEL', payload: { id } });
        }
    }, [colorLine, legendDispatch, label, shape, id, hidden]);
    if (hidden)
        return null;
    return (_jsxs("g", { children: [isVisible && _jsx(BarSeriesRender, { ...lineProps }), _jsx(ScatterSeries, { ...otherProps, hidden: !displayMarkers && !pointLabel && !displayErrorBars, displayMarkers: displayMarkers, id: id })] }));
}
function BarSeriesRender({ id, data, xAxis, yAxis, lineStyle, transform, }) {
    // Get scales from context
    const { axisContext, colorScaler } = usePlotContext();
    const [xScale, yScale] = validateAxis(axisContext, xAxis, yAxis);
    const color = colorScaler(id);
    if (xScale === undefined || yScale === undefined) {
        return null;
    }
    // default style
    const style = {
        stroke: color,
        strokeWidth: 2,
        ...lineStyle,
    };
    return (_jsx("g", { transform: transform, children: data.map(({ x, y }) => (_jsx("line", { style: style, x1: xScale(x), x2: xScale(x), y1: yScale(y), y2: yScale(0) }, `${x}-${y}`))) }));
}
//# sourceMappingURL=BarSeries.js.map